import { Permissao } from "@/contexts/autorizacao/permissao/model/Permissao";
import { api } from "@/shared/api/api";

export const createPermissaoApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<Permissao[]>(`/permissoes/todas`, {
      headers,
    });
    return data;
  };

  return { listAll };
};
